import React from 'react';
import { observer } from 'mobx-react';
import { GridItemStore } from '@seedlang/stores';
import { AppUI } from '@seedlang/state';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class GridItemCreate extends React.Component {

  onCreate = name => {
    const data = {
      name,
      siteId: AppUI.site.id,
      ...this.props.additionalData,
    };
    GridItemStore.create({data}, this.props.afterCreate);
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default GridItemCreate;
